import React, { CSSProperties, useMemo, useState, useEffect } from "react";
// CSS
import { Modal, Label, Icon, TextArea, Form } from "semantic-ui-react";
import config from "config/config";

type ModalGalleryProps = {
  // data
  items: ItemType[];
  open: boolean;
  visitDate: string;
  doctorName: string;
  divisionName: string;
  // callback
  onClose: () => any;
};

type ItemType = {
  id: number;
  doctor: number | null;
  image: string;
  description: string;
};

const styles = {
  cardList: {
    overflow: "hidden",
    width: "100%",
    display: "flex",
    padding: "0 20px 0 0",
  } as CSSProperties,
  boxCard: {
    height: "110px",
    width: "31%",
    margin: "0 10px",
    flexShrink: 0,
    display: "flex",
    justifyContent: "center",
    cursor: "pointer",
    padding: "5px",
  } as CSSProperties,
  boxIconAngle: {
    background: "#E0E0E0",
    display: "flex",
    alignItems: "center",
    fontSize: "2rem",
    justifyContent: "center",
    color: "#828282",
    cursor: "pointer",
  } as CSSProperties,
  slide: {
    display: "grid",
    gridTemplateColumns: "30px auto 30px",
    height: "110px",
    marginTop: "20px",
  } as CSSProperties,
  ribbon: {
    backgroundColor: "#063E82",
    padding: "7px 35px",
    position: "absolute",
    color: "white",
    top: "12px",
    borderRadius: 0,
  } as CSSProperties,
  closeIcon: {
    position: "absolute",
    top: "10px",
    right: "7px",
    cursor: "pointer",
  } as CSSProperties,
  detail: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    alignItems: "center",
    marginTop: "40px",
  } as CSSProperties,
  previewImage: {
    width: "100%",
    height: "auto",
    objectFit: "contain",
    maxHeight: "360px",
  } as CSSProperties,
};

const MAX_VIEW_CARD = 3;

const ModalGallery: React.FunctionComponent<ModalGalleryProps> = (props) => {
  const [viewIndex, setViewIndex] = useState<number>(0);
  const [selectedImage, setSelectedImage] = useState<ItemType | null>(null);

  useEffect(() => {
    setSelectedImage(props.items?.[0] || null);
  }, [props.items]);

  const subItems = useMemo(() => {
    return (props.items || []).slice(viewIndex, MAX_VIEW_CARD + viewIndex);
  }, [viewIndex, props.items]);

  const handleChangeStep = (action: "forward" | "backward") => {
    let index = action === "backward" ? +viewIndex - 1 : +viewIndex + 1;
    const last = index === (props.items?.length || 0) - MAX_VIEW_CARD + 1;
    console.log(last);
    index = index < 0 ? 0 : last ? index - 1 : index;
    setViewIndex(index);
  };

  let selectedImageLink  = selectedImage?.image
  if (! selectedImage?.image.includes("http")) {
    selectedImageLink = config.API_HOST + selectedImage?.image
  }

  return (
    <div>
      <Modal open={props.open} closeOnDimmerClick onClose={props.onClose}>
        <div style={styles.ribbon}>Gallery</div>
        <div style={styles.closeIcon} onClick={props.onClose}>
          <Icon name="close" style={{ fontSize: "1.2rem" }} />
        </div>
        <div style={{ padding: "1.5rem" }}>
          <div style={styles.detail}>
            <div style={{ display: "flex" }}>
              <label style={{ marginRight: "25px" }}>
                <strong>Visit date:</strong> {props.visitDate}
              </label>
              <label style={{ marginRight: "25px" }}>
                <strong>Dentist:</strong> {props.doctorName}
              </label>
              <label style={{ marginRight: "25px" }}>
                <strong>Clinic:</strong> {props.divisionName}
              </label>
            </div>
            <div>
              <strong>จำนวนภาพ:</strong> {props.items?.length || "-"}
            </div>
          </div>
          {/* <br /> */}
          <div style={styles.slide}>
            <div style={styles.boxIconAngle} onClick={() => handleChangeStep("backward")}>
              <Icon name="angle left" />
            </div>
            <div>
              {
                <div style={styles.cardList}>
                  {subItems.map((item: any, idx: number) => { 

                    let imageLnk = item?.image
                    if (!item?.image.includes("http")) {
                      imageLnk = config.API_HOST + item?.image
                    }
                    return (
                    <div
                      key={item.id}
                      style={{
                        ...styles.boxCard,
                        backgroundColor: item.id === selectedImage?.id ? "#2d9cdb" : "#E0E0E0",
                      }}
                      onClick={() => setSelectedImage(item)}
                    >
                      <img src={`${imageLnk}`} style={{ height: "100%", objectFit: "cover", width: "100%" }} />
                    </div>
                  )})}
                </div>
              }
            </div>
            <div style={styles.boxIconAngle} onClick={() => handleChangeStep("forward")}>
              <Icon name="angle right" style={{ margin: 0 }} />
            </div>
          </div>

          <div style={{ marginTop: "15px" }}>
            {selectedImage?.image && <img src={`${selectedImageLink}`} alt="preview.image" style={styles.previewImage} />}
          </div>

          <div style={{ marginTop: "25px" }}>
            <Form>
              <Form.Field control={TextArea} label="Detail" value={selectedImage?.description} />
            </Form>
          </div>
        </div>
      </Modal>
    </div>
  );
};

ModalGallery.defaultProps = {
  // data
  items: [],
  open: false,
  visitDate: "",
  doctorName: "",
  divisionName: "",
  // callback
  onClose: () => {},
} as ModalGalleryProps;

export default ModalGallery;
